module.exports = __webpack_public_path__ + "0862b6ea45006bed33dc2c13f51b1f4c.png";